import CallbackReminderCard from './CallbackReminderCard/CallbackReminderCard'
import useCallbackReminderPopup from './useCallbackReminderPopup'
import { ReminderStack } from './styled-components'

const CallbackReminderPopup = () => {
  const { cards, stackLabel, stackRef } = useCallbackReminderPopup()

  if (cards.length === 0) return null

  return (
    <ReminderStack
      ref={stackRef}
      aria-label={stackLabel}
      aria-live='polite'
      aria-relevant='additions'
      data-testid='callback-reminder-stack'
    >
      {cards.map(({ id, ...card }) => (
        <CallbackReminderCard key={id} {...card} />
      ))}
    </ReminderStack>
  )
}

export default CallbackReminderPopup
